import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { JBFooter } from '@juliusbaer-gcrm/gcrm-frontend-components';

const EditFooter = (props: {
  onClick: any;
  onClickCapture: () => void;
  disabled: boolean;
  onSubmitClick: () => void;
  onSaveClick: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <JBFooter
      splitLayout
      leftButton={
        <Button
          onClick={props.onClick}
          onClickCapture={props.onClickCapture}
          id="contactnoteform-cancel-button"
          size="small"
          variant="outlined"
        >
          Cancel
        </Button>
      }
      additionalRightButton={
        <LoadingButton
          loading={props.disabled}
          variant="outlined"
          onClick={props.onSaveClick}
          size="small"
          id="contactnoteform-save-button"
        >
          {t('noteform.footer.save', 'Save')}
        </LoadingButton>
      }
      rightButton={
        <LoadingButton
          loading={props.disabled}
          variant="contained"
          onClick={props.onSubmitClick}
          size="small"
          id="contactnoteform-submit-button"
        >
          {t('noteform.footer.submit', 'Submit')}
        </LoadingButton>
      }
    />
  );
};

export default EditFooter;
